import { render } from "./ChatLayout.vue?vue&type=template&id=48202768"
import script from "./ChatLayout.vue?vue&type=script&lang=js"
export * from "./ChatLayout.vue?vue&type=script&lang=js"

import "./ChatLayout.vue?vue&type=style&index=0&id=48202768&lang=css"

import exportComponent from "/home/forge/staging.virtualcp.app/releases/20260928150148/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__